module.exports = __webpack_public_path__ + "img/870.43bd4cb1.png";